import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';

import { withStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import "./Form.css";
import validate from "../../utils/validate";
import green from "@material-ui/core/colors/green";
import FormGroup from '@material-ui/core/FormGroup';

const styles = theme => ({
    customChecked: {
        color: "#0A5DB8 !important"
    },
    customRoot: {
        display: "flex",
        height: "36px"
    },
    customLabel: {
        fontSize: "14px"
    }
});

const convertToArray = (str) => {
    return str !== null ? str.split('|') : [];
}

const convertToString = (arr) => {
    return arr.join('|');
}

class CheckBox extends Component {
    state = {
        error: false,
        errorMessage: "",
        helpText: "",
        value: [],
    };

    componentDidMount() {
        this.setState({
            value: convertToArray(this.props.value)
        })
        this.validateFn(this.props.value, this.props.required, this.props.regEx);
    }

    componentWillReceiveProps(nextProps) {
        this.validateFn(nextProps.value, nextProps.required, nextProps.regEx);
    }

    handleChange = (event) => {
        const value = event.target.value;
        let checkedValueArray = [];
        if (event.target.checked == true) {
            checkedValueArray = [...this.state.value, value]
            let noneIndex = checkedValueArray.indexOf('None')
            if (checkedValueArray.length > 1 && (noneIndex != -1 || noneIndex == 0)) {
                checkedValueArray.splice(noneIndex, 1);
            }
        }
        else {
            checkedValueArray = [...this.state.value]
            const index = checkedValueArray.indexOf(value)
            checkedValueArray.splice(index, 1);
        }

        this.validateFn(convertToString(checkedValueArray), this.props.required, this.props.regEx)

        this.setState({
            value: checkedValueArray
        }, () => {
            this.validateFn(convertToString(this.state.value), this.props.required, this.props.regEx);
        })
    };

    validateFn(value, required, regEx) {
        let errorObj = validate(value, required, regEx);
        this.setState(() => errorObj);
        if (this.props.onChanged) {
            this.props.onChanged(value, errorObj.error);
        }
    }

    displayHelpText = (event) => {
        let helpText = "";
        let selectedOption = this.props.dataSource.filter(
            i => i.value === event.target.value
        );
        if (selectedOption.length > 0) {
            helpText = selectedOption[0].helpText ? selectedOption[0].helpText : "";
        }
        this.setState(() => ({ helpText: helpText }));
    };

    render() {
        const {
            label,
            name,
            value,
            dataSource,
            editable,
            required,
            showError,
            classes
        } = this.props;
        return (
            <div>
                <FormLabel className="check-box-label">
                    <strong>{label}</strong>
                    {this.state.error && showError ? (
                        <span className="error-text">({this.state.errorMessage})</span>
                    ) : (
                            ""
                        )}
                </FormLabel>
                <FormGroup >
                    {dataSource.map((item, i) => (
                        <FormControlLabel
                            key={item.value}
                            classes={{ root: classes.customRoot, label: classes.customLabel }}
                            disabled={!editable}
                            value={item.value}
                            control={<Checkbox
                                classes={
                                    { checked: classes.customChecked }}
                                onChange={this.handleChange}
                                checked={
                                    this.state.value.indexOf(item.value) == -1 ? false : true
                                }
                            />}
                            label={item.display}
                            onChange={this.displayHelpText}
                        />
                    ))}
                    {this.state.helpText != "" ?
                        (<FormHelperText filled={true}>{this.state.helpText}</FormHelperText>) : ""
                    }
                </FormGroup>
            </div>
        );
    }
}

CheckBox.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    dataSource: PropTypes.array,
    editable: PropTypes.bool,
    required: PropTypes.bool,
    error: PropTypes.string,
    onChanged: PropTypes.func
};

export default withStyles(styles)(CheckBox);


// WEBPACK FOOTER //
// ./src/components/form/CheckBoxField.js